const PopupBaseStation = data => {
    const { address, location, networkType } = data
    return `<div>
                <h2 style="color: black;">${address}</h2>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>Latitude:</strong> ${location.coordinates[1]}</p>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>Longitude:</strong> ${location.coordinates[0]}</p>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>Network type:</strong> ${networkType}</p>
                <br />
                <p style="margin: 0; font-size: 16px; color: black;"><strong>CID:</strong> ${data.cid || "-"}</p>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>eNB:</strong> ${data.eNB || "-"}</p>
            </div>`
}

const PopupKpi = data => {
    const { connectivity, createdAt, collectionTimestamp } = data
    const { signal } = connectivity

    const date = formatDate(createdAt)
    const time = formatTime(collectionTimestamp)
    switch (connectivity.type) {
        case 'LTE':
            return `<div>
                <h2 style="color: black;">${connectivity.type}</h2>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>Date:</strong> ${date}</p>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>Time:</strong> ${time}</p>
                <br />
                <p style="margin: 0; font-size: 16px; color: black;"><strong>CID:</strong> ${connectivity.cell.cid}</p>            
                <p style="margin: 0; font-size: 16px; color: black;"><strong>eNB:</strong> ${eNBFromCid(connectivity.cell.cid)}</p>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>RSRP:</strong> ${signal.rsrp}</p>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>RSRQ:</strong> ${signal.rsrq}</p>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>RSSNR:</strong> ${signal.rssnr}</p>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>Level:</strong> ${signal.level}</p>
            </div>`
        case 'WCDMA':
            return `<div>
                <h2 style="color: black;">${connectivity.type}</h2>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>Date:</strong> ${date}</p>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>Time:</strong> ${time}</p>
                <br />
                <p style="margin: 0; font-size: 16px; color: black;"><strong>RSCP:</strong> ${signal.rscp}</p>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>Ec/Io:</strong> ${signal.ecio}</p>
                <p style="margin: 0; font-size: 16px; color: black;"><strong>Level:</strong> ${signal.level}</p>
            </div>`

        default:
            break
    }
}

/**
 * Convert date to dd-mm-yyyy format
 * @param {Date} date date to transform
 * @returns string
 */
const formatDate = d => {
    const date = new Date(d)
    const day = ('0' + date.getDate()).slice(-2)
    const month = ('0' + Number(date.getMonth() + 1)).slice(-2)
    const year = date.getFullYear()

    return `${day}/${month}/${year}`
}

/**
 * Convert unix time to HH:MM:SS format
 * @param {Date} time time to transform
 * @returns string
 */
const formatTime = time => {
    const unixFormatted = Math.ceil(time / 1000)
    // Create a new JavaScript Date object based on the timestamp
    // multiplied by 1000 so that the argument is in milliseconds, not seconds.
    const date = new Date(unixFormatted * 1000)
    // Hours part from the timestamp
    const hours = date.getHours()
    // Minutes part from the timestamp
    const minutes = '0' + date.getMinutes()
    // Seconds part from the timestamp
    const seconds = '0' + date.getSeconds()

    // Will display time in 10:30:23 format
    const formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2)

    return formattedTime
}

const eNBFromCid = cid => {
    if (cid){
        const eNBHex = cid.toString(16).substring(0, 5)
        const eNB = parseInt(eNBHex, 16)
        return eNB
    }
}

export { PopupBaseStation, PopupKpi }
